import { Api } from 'utils';

class SurveyService {
	
	static check = async (params?: any) => Api.createResponse('survey/check',params);
	static save = async (params?: any) => Api.createResponse('survey/save',params);

}

export default SurveyService;